import { Range } from "@/models/Range";

export class FilterTemplate {
  public Id!: string;
  public FieldName!: string;
  public Title!: string;
  public Value: number | Range | undefined;
  public DefaultValue: string | undefined;
  public MinValue!: number;
  public MaxValue!: number;
  public Step!: number;
  public IsDynamic!: boolean;
  public IsRange!: boolean;
  public FieldType!: string;
  public Unit!: string;
  public Size: number | undefined;
  public FieldPath: string | undefined;
  public Color: string | undefined;
}

export abstract class FilterValue {
  constructor(public Id: string, public Field: string, public Range: boolean) {}
}

export class FilterRangeValue extends FilterValue {
  constructor(public Id: string, public Field: string, public From: number, public To: number) {
    super(Id, Field, true);
  }
}

export class FilterSingleValue extends FilterValue {
  constructor(public Id: string,  public Field: string, public Value: number) {
    super(Id, Field, false);
  }
}
